import React, { useEffect } from 'react';
import { RouteComponentProps, Switch } from 'react-router-dom';
import { Avatar, Breadcrumb, Card, Col, Descriptions, Divider, Row, Tag } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { BankOutlined } from '@ant-design/icons';
import { getAnneeScolaire } from './annee-scolaire.reducer';
import { StatusAnneeScolaire } from 'app/shared/model/anneeScolaire.model';
import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { TextFormat } from 'react-jhipster';
import { getEcole } from '../ecole/ecole.reducer';

export const AnneeScolaireDetail = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getAnneeScolaire(props.match.params.id));
  }, []);

  const ecoleEntity = useAppSelector(state => state.ecole.entity);
  const anneeScolaire = useAppSelector(state => state.anneeScolaire.entity);
  return (
    <>
      <Breadcrumb className="p-4">
        <Breadcrumb.Item>
          <a href="/">{ecoleEntity.nom}</a>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <a href="/annee-scolaire">Annees Scolaires</a>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <a href={`annee-scolaire/${anneeScolaire.id}/details`}>Details</a>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card>
        <Row className="justify-content-center">
          <Col lg={{ span: 6 }} xs={{ span: 24 }} sm={{ span: 8 }} md={{ span: 5 }} className="p-4">
            <Avatar size={{ xs: 80, sm: 100, md: 100, lg: 120, xl: 150, xxl: 100 }} style={{}} icon={<BankOutlined />} />
            <Descriptions column={1} className="ml-2 pt-4">
              <Descriptions.Item label="Status">
                {anneeScolaire.statutAnneeScolaire === StatusAnneeScolaire.ACTIVE ? (
                  <Tag color="green">{anneeScolaire.statutAnneeScolaire}</Tag>
                ) : (
                  <Tag color="red">{anneeScolaire.statutAnneeScolaire}</Tag>
                )}
              </Descriptions.Item>
            </Descriptions>
          </Col>

          <Divider type="vertical" style={{ height: 'auto' }} />
          <Col lg={{ span: 10 }} xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 9 }}>
            <h2 style={{ textAlign: 'center' }} className="p-2">
              {' '}
              Année Scolaire {anneeScolaire.nom}{' '}
            </h2>
            <span>
              <Descriptions column={1}>
                <Descriptions.Item label="Nom">{anneeScolaire.nom}</Descriptions.Item>
                <Descriptions.Item label="Date Ouverture">
                  {' '}
                  <TextFormat type="date" value={anneeScolaire.dateDebut} format={APP_LOCAL_DATE_FORMAT} />
                </Descriptions.Item>
                <Descriptions.Item label="Date de Clôture">
                  <TextFormat type="date" value={anneeScolaire.dateCloture} format={APP_LOCAL_DATE_FORMAT} />
                </Descriptions.Item>
              </Descriptions>
            </span>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default AnneeScolaireDetail;
